import PropTypes from 'prop-types';
import { useDropTarget } from './dropTargets';

/** Rendered by a lit spot: dropping the dragged card on `name` does `commit`, the same as tapping the spot. */
const DropTarget = ({ name, commit }) => {
  useDropTarget(name, commit);
  return null;
};

DropTarget.propTypes = {
  name: PropTypes.string.isRequired,
  commit: PropTypes.func.isRequired,
};

export default DropTarget;
